import type { PageQuery } from '@repo/shared'
import { useCallback, useState } from 'react'

/** 모든 표는 10개씩 (2026-09-17 결정: 고전적인 페이지네이션, 페이지 크기 선택 없음) */
export const PAGE_SIZE = 10

/** 서버 페이지네이션 상태 (page · perPage 를 쿼리로 보내는 표) */
export function usePage(initialPerPage = PAGE_SIZE) {
  const [query, setQuery] = useState<PageQuery>({ page: 1, perPage: initialPerPage })
  const setPage = useCallback((page: number) => setQuery((q) => ({ ...q, page })), [])
  const setPerPage = useCallback((perPage: number) => setQuery({ page: 1, perPage }), [])
  return { query, setPage, setPerPage }
}

/** 이미 다 받아 둔 배열을 10개씩 잘라 보여주는 표. 목록이 바뀌어 페이지가 범위를 벗어나면 마지막 페이지로 */
export function usePagedList<T>(items: T[] | null, perPage = PAGE_SIZE) {
  const [page, setPage] = useState(1)
  const total = items?.length ?? 0
  const pages = Math.max(1, Math.ceil(total / perPage))
  const current = Math.min(page, pages)
  const slice = items ? items.slice((current - 1) * perPage, current * perPage) : []
  return { page: current, setPage, perPage, total, slice }
}
